import React, { useState, useRef, useEffect } from 'react'
import { Box, Typography, Button, TextField } from '@mui/material'
import TagsList from './TagsList'
import statusStore from '../../../stores/statusStore'
import logger from '../../../utils/logger'

function Tags() {
	const [showForm, setShowForm] = useState(false)
	const [tagName, setTagName] = useState('')
	const [tagColor, setTagColor] = useState('#000000')
	const colorInputRef = useRef(null)

	const mayManage = statusStore.canManageDictionaries

	useEffect(() => {
		if (statusStore.tags.length === 0) {
			statusStore.fetchTags('Tags.jsx')
		}
	}, [])

	const handleOpenForm = () => {
		setShowForm(true)
	}

	const handleCancel = () => {
		setTagName('')
		setTagColor('#000000')
		setShowForm(false)
	}

	const handleSave = () => {
		if (!tagName.trim()) {
			alert('Название тега не должно быть пустым')
			return
		}
		/* logger.log('Сохранить тег:', { tagName, tagColor }) */
		// Здесь можно вызвать функцию сохранения тега (например, через store)
		// После сохранения сбрасываем поля и скрываем форму:
		setTagName('')
		setTagColor('#000000')
		setShowForm(false)
		const newTag = {
			tagName,
			tagColor,
		}
		statusStore.addTag(newTag)
	}

	const handleColorChange = e => {
		setTagColor(e.target.value)
	}

	return (
		<div>
			<Box className='mt-4 p-4 rounded shadow'>
				<Typography variant='h6' className='font-semibold text-lg'>
					Теги
				</Typography>
				<p className='font-thin text-xs'>видны только вам</p>

				{mayManage && <div className='mt-4'>
					<TagsList />
				</div>}

				<div className='mt-4'>
					{!showForm && (
						<Button variant='outlined' onClick={handleOpenForm} size='small'>
							Добавить тег
						</Button>
					)}

					{showForm && (
						<Box
							className='mt-4'
							sx={{
								maxWidth: 400,
								p: 2,
								border: '1px solid #ccc',
								borderRadius: 1,
							}}
						>
							<TextField
								fullWidth
								label='Название тега'
								value={tagName}
								onChange={e => setTagName(e.target.value)}
								margin='normal'
							/>

							<Box sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
								<Box
									sx={{
										width: 40,
										height: 40,
										borderRadius: '50%',
										backgroundColor: tagColor,
										mr: 2,
									}}
								/>
								<Button
									variant='outlined'
									onClick={() => colorInputRef.current.click()}
								>
									цвет
								</Button>
								<input
									type='color'
									ref={colorInputRef}
									value={tagColor}
									onChange={handleColorChange}
									style={{ display: 'none' }}
								/>
							</Box>

							<Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
								<Button
									variant='outlined'
									onClick={handleCancel}
									sx={{ mr: 1 }}
								>
									Отмена
								</Button>
								<Button variant='contained' onClick={handleSave}>
									Сохранить
								</Button>
							</Box>
						</Box>
					)}
				</div>
			</Box>
		</div>
	)
}

export default Tags
